import React, { Component } from "react";

import { connect } from "react-redux";

import Header from "./Components/Header";
import Content from "./Components/Content";
import CalculatorBox from "./Components/CalculatorBox";

import "./App.css";
import M from "materialize-css";

import Spinner from "./Components/Spinner";
import Carousel from "./Components/Carousel";
import Callback from "./Components/Callback";
import ChatBot from "./Components/ChatBot";
import Portfolio from "./Components/Protfolio";
import VideoGallery from "./Components/VideoGallery";
import Testemonials from "./Components/Testemonials";

import {
  changeLanguage,
  fetchLoaderRun,
  changeTeam,
  setSetvices,
  updateService,
  setCzasPracy,
  setMessage
} from "./actions";
import Footer from "./Components/Footer/Footer";

class App extends Component {
  state = {
    language: this.props.language,
    testemonials: null
  };
  preloadElem = null;
  spinner = null;

  //store = this.props.store;

  getTestemonials = () => {
    return this.state.testemonials;
  };

  updateTestemonials = testemonials => {
    this.setState({ testemonials });
  };

  componentDidMount() {
    this.preloadElem = document.querySelector(".App");
    this.spinner = document.querySelector(".spinner");
    // this.unsubscribe = this.store.subscribe(() => {
    // this.setState({
    //   language: this.props.language
    // });
    // });
    const elems = document.querySelectorAll(".parallax");
    M.Parallax.init(elems, { responsiveThreshold: 800 });

    setTimeout(() => {
      this.spinner.classList.add("is-preload");
      this.preloadElem.classList.remove("is-preload");
    }, 100);
  }

  componentWillMount() {
    // add grecaptcha script on the page
    const imported = document.createElement("script");
    imported.src = "https://www.google.com/recaptcha/api.js?render=explicit";
    imported.defer = true;
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(imported, firstScriptTag);
    //document.head.appendChild(imported);
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextProps.language !== this.state.language) {
      this.spinner.classList.remove("is-preload");
      this.preloadElem.classList.add("is-preload");
      this.setState({
        language: nextProps.language
      });
    }
  }

  componentDidUpdate() {
    setTimeout(() => {
      this.spinner.classList.add("is-preload");
      this.preloadElem.classList.remove("is-preload");
    }, 100);
  }

  render() {
    return (
      <>
        <Spinner color={"#1d99b4"} />
        <div className="App is-preload">
          <div className="wrapper-box">
            <Header />
            <Content />
            <CalculatorBox />
            <Carousel />
            <Callback />
            <Portfolio />
            <VideoGallery />
            <Testemonials
              getTestemonials={this.getTestemonials}
              updateTestemonials={this.updateTestemonials}
            />
            <Footer />
            <ChatBot />
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  store: state,
  language: state.language,
  langBase: state.langBase,
  showModal: state.showModal,
  fetching: state.fetching,
  ekipa: state.ekipa,
  services: state.services,
  stepBtn: state.stepBtn,
  czasPracy: state.czasPracy,
  message: state.message,
  messageText: { ...state.messageText }
});

const mapDispatchToProps = {
  changeLanguage,
  fetchLoaderRun,
  changeTeam,
  setSetvices,
  updateService,
  setCzasPracy,
  setMessage
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
